



































import Vue from 'vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import { version } from './version'

export default Vue.extend({
  data () {
    return {
      ...mapState(['indexedDBRequest', 'appTitle']),
      appVersion: version
    }
  },

  computed: {
    ...mapGetters(['getPinnedForms', 'getSelectedSeismicForm'])
  },

  methods: {
    ...mapActions(['initializeIndexedDB'])

  },

  created () {
    setTimeout(this.initializeIndexedDB, 1000)
    console.log('Loaded store')
  }
})

